import { Grid, TextField } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IForm from '../../../components/i-form/i-form.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import { formatTo2Decimal, isNotNull } from '../../common/util.services';
import { GridRowsProp, useGridApiRef } from '@mui/x-data-grid';
import AmzVirtualProductDetail from './product-detail.component';
import { getById, saveProduct } from './product.services';

const AmzVirtualProduct = (props: any) => {
  const [title, setTitle] = useState<string>('Add Virutal Product');
  const appContext = useContext(AppContext);
  const apiRef = useGridApiRef();
  const navigate = useNavigate();
  const rows: GridRowsProp = [];
  const params = useParams()
  const rowId = params.rowId;
  const [productData, setProductData] = useState<any>({price: 0});
  const [productDetail, setProductDetail] = useState(rows);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    if (isNotNull(rowId)) {
      getById(rowId, appContext,
        (response: any) => {
          setTitle('Edit Virtual Product');
          setProductData(response.data);
          setProductDetail(response.data.virtualProduct);
          setLoader(false);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          setLoader(false);
        });
    } else {
      setLoader(false);
    }
  }, []);

  const validProduct = () => {
    let valid = true;

    if(productDetail.length <= 0) {
      appContext.setDialogMessage('Add product details.');
      return false;
    }

    return valid;
  }

  const onSubmit = (data: any) => {
    if (validProduct()) {
      data.virtualProduct = productDetail;
      data.price = productData.price;
      saveProduct(data, appContext,
        (response: any) => {
          navigate('/amazon/virtualproduct');
          appContext.setSuccessMessage(response.message)
          appContext.setShowLoader(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message)
        });
    }
  }

  function updatePrice(selectedRows: any) {
    let price = 0;
    for(let i = 0; i < selectedRows.length; ++i) {
      price += selectedRows[i].price;
    }
    productData.price = price;
  }

  const onRowSelection = (selectedRows: any) => {
    setProductDetail(selectedRows);
    updatePrice(selectedRows);
  }

  const onRowDelete = (selectedRows: any) => {
    setProductDetail(selectedRows);
    updatePrice(selectedRows);
  }

  const getMainComponent = () => {
    return <Grid container spacing={1}>
      <Grid xs={9}>
        <ITextField name='sku' label='Virtual Product SKU' required={true} disabled={false}/>
      </Grid>
      <Grid xs={3}>
        <TextField name='price' label='Price' required={false} disabled={true} value={formatTo2Decimal(productData.price)}
          margin='dense' inputProps={{ style: { height: "9px"}}} size='medium'/>
      </Grid>
      <Grid xs={12}>
        <AmzVirtualProductDetail onRowSelection={onRowSelection} onRowDelete={onRowDelete} 
         productDetail={productDetail} apiRef={apiRef}/>
      </Grid>
    </Grid>
  }

  return loader ? <></> : <IForm formData={productData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default AmzVirtualProduct;